import React, { useState, useEffect, Fragment } from 'react';
import {
  Row,
  Input,
  FormGroup,
  CustomInput,
  Button,
  ButtonGroup,
  Form,
  Modal,
  ModalBody,
  Spinner,
  DropdownToggle,
  DropdownMenu,
  Label,
  ModalHeader,
  UncontrolledDropdown,
  DropdownItem,
} from 'reactstrap';
import {
  Colxx,
  Separator,
} from '../../../../../components/common/CustomBootstrap';

import { AxiosAPI, getGroupID } from '../../../../../helpers/AxiosAPI';

import {
  gAPI_Property_List_By_Group,
  API_Ingetration_Channels,
  API_RMS,
  gAPI_RMS,
} from '../../../../../constants/APIs';

import Validation from '../../../../../components/Validation';
import CopyToClipboard from 'react-copy-to-clipboard';
import { NotificationManager } from '../../../../../components/common/react-notifications';
let arr = [];
export default function RMSIntegration({ visible, toggle, id }) {
  const [isLoading, setIsLoading] = useState(false);
  const [property, setProperty] = useState([]);
  const [selectedproperty, setSeletedProperty] = useState([]);
  const [open, setOpen] = useState(false);
  const [clientProperties, setClientProperties] = useState([]);
  const [onlineAgents, setOnlineAgents] = useState([]);
  const [msg, setMsg] = useState([]);
  const [inputData, setInputData] = useState({
    GroupId: getGroupID(),
    Name: '',
    Properties: [],
    SessionTimeoutInSeconds: 600,
    DefaultLanguage: 'en-US',
    clientSecret: '',
    clientId: '',
    propertyId: '',
    clientUrl: '',
    onlineAgentId: '',
    addTax: false,
  });
  const [maskData, setMaskData] = useState({
    clientId: '',
    clientSecret: '',
  });
  useEffect(() => {
    let body = {
      channels: ['HelpCenter', 'HelpCenterGroup'],
    };

    if (id !== undefined) {
      AxiosAPI({
        method: 'get',
        url: `${API_RMS}/${id}?group_id=${getGroupID()}`,
      })
        .then((json) => {
          let obj = {
            Name: json.data.name,
            clientId: json.data?.channelDetails?.clientId,
            clientSecret: json.data?.channelDetails?.clientSecret,
            propertyId: json.data?.channelDetails?.propertyId,
            onlineAgentId: json.data?.channelDetails?.onlineAgentId,
            addTax: json.data?.channelDetails?.addTax,
            clientUrl: json.data?.channelDetails?.clientUrl,
          };
          setMaskData({
            ...maskData,
            clientId: mask(json.data?.channelDetails?.clientId),
            clientSecret: mask(json.data?.channelDetails?.clientSecret),
          });
          setIsLoading(true);
          AxiosAPI({
            method: 'get',
            url: `${gAPI_RMS}/client-details?client_id=${json.data?.channelDetails?.clientId}&client_secret=${json.data?.channelDetails?.clientSecret}`,
            data: body,
          }).then((res) => {
            obj.clientUrl = res.data?.clientUrl;
            setClientProperties(res.data?.properties);
          });
          AxiosAPI({
            method: 'get',
            url: `${gAPI_RMS}/online-agents?client_id=${json.data?.channelDetails?.clientId}&client_secret=${json.data?.channelDetails?.clientSecret}`,
          }).then((res) => {
            obj.clientUrl = res.data?.clientUrl;
            setOnlineAgents(res.data);
          });
          let filterList = [];
          if (json.data.properties !== null) {
            filterList = json.data.properties.filter(
              (elem) => elem !== undefined || null
            );
          }
          setSeletedProperty(filterList);
          obj.Properties = filterList;
          setInputData(obj);
          setIsLoading(false);
        })
        .catch((err) => console.log('err', err));

      AxiosAPI({
        method: 'get',
        url: `${gAPI_Property_List_By_Group}/?group_id=${getGroupID()}`,
      })
        .then((res) => {
          setProperty([...res.data]);
        })
        .catch((err) => console.error(err));
    } else {
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Property_List_By_Group}/?group_id=${getGroupID()}`,
      })
        .then((res) => {
          setProperty([...res.data]);
        })
        .catch((err) => console.error(err));
    }
  }, [id]);

  const handleSave = async () => {
    if (inputData.clientUrl !== '') {
      if (id !== undefined) {
        let body = inputData;
        AxiosAPI({
          method: 'put',
          url: `${API_RMS}/${id}?group_id=${getGroupID()}`,
          data: body,
        }).then(() =>
          setTimeout(() => {
            window.location.reload();
          }, 300)
        );
        toggle();
      } else {
        let body = inputData;
        AxiosAPI({
          method: 'post',
          url: API_RMS,
          data: body,
        }).then((res) => {
          if (
            res.data.HttpStatusCode !== undefined &&
            res.data.HttpStatusCode === 400 &&
            res.data.Messages !== undefined &&
            res.data.Messages !== null &&
            res.data.Messages.length > 0
          ) {
            setMsg(res.data.Messages);
            setOpen(true);
          }
          setTimeout(() => {
            window.location.reload();
          }, 300);
        });
      }
    }
  };

  const handleCheckChange = (e) => {
    if (
      selectedproperty.includes(e.target.value) &&
      selectedproperty.length > 0
    ) {
      let itemsList = selectedproperty.filter(
        (item) => item !== e.target.value || null || undefined
      );
      setSeletedProperty(itemsList);
      setInputData({ ...inputData, Properties: itemsList });
    } else {
      let lengthArry = selectedproperty.length;
      selectedproperty[lengthArry] = e.target.value;
      setSeletedProperty(selectedproperty);
      setInputData({ ...inputData, Properties: selectedproperty });
    }
  };

  const handleClietIdChange = (e) => {
    e.persist();
    setInputData({ ...inputData, clientId: e.target.value });
    setMaskData({ ...maskData, clientId: mask(e.target.value) });
    if (inputData?.clientUrl !== '' && e.target.value !== '') {
      setIsLoading(true);
      AxiosAPI({
        method: 'get',
        url: `${gAPI_RMS}/client-details?client_id=${e.target.value}&client_secret=${inputData?.clientSecret}`,
      }).then((res) => {
        setInputData({ ...inputData, clientUrl: res.data?.clientUrl });
        setClientProperties(res.data?.properties);
        setIsLoading(false);
      });
      setIsLoading(true);
      AxiosAPI({
        method: 'get',
        url: `${gAPI_RMS}/online-agents?client_id=${inputData?.clientId}&client_secret=${e.target.value}`,
      }).then((res) => {
        setInputData({
          ...inputData,
          clientUrl: res.data?.clientUrl,
          clientSecret: e.target.value,
        });
        setOnlineAgents(res.data);
        setIsLoading(false);
      });
    }
  };

  const handleClietSecretChange = (e) => {
    e.persist();
    setInputData({ ...inputData, clientSecret: e.target.value });
    setMaskData({ ...maskData, clientSecret: mask(e.target.value) });
    if (inputData?.clientId !== '' && e.target.value !== '') {
      setIsLoading(true);
      AxiosAPI({
        method: 'get',
        url: `${gAPI_RMS}/client-details?client_id=${inputData?.clientId}&client_secret=${e.target.value}`,
      }).then((res) => {
        setInputData({
          ...inputData,
          clientUrl: res.data?.clientUrl,
          clientSecret: e.target.value,
        });
        setClientProperties(res.data?.properties);
        setIsLoading(false);
      });
      setIsLoading(true);
      AxiosAPI({
        method: 'get',
        url: `${gAPI_RMS}/online-agents?client_id=${inputData?.clientId}&client_secret=${e.target.value}`,
      }).then((res) => {
        setInputData({
          ...inputData,
          clientUrl: res.data?.clientUrl,
          clientSecret: e.target.value,
        });
        setOnlineAgents(res.data);
        setIsLoading(false);
      });
    }
  };

  const handleChange = (e) => {
    e.persist();
    setInputData({ ...inputData, [e.target.name]: e.target.value });
  };
  const mask = (value) => {
    let maskedValue = '';
    for (let i = 0; i < value.length - 2; i++) {
      maskedValue += '*';
    }
    return maskedValue + value.substring(value.length - 2, value.length);
  };
  return (
    <Fragment>
      <Modal isOpen={visible} toggle={toggle} size="md">
        <ModalBody>
          <Row className="mb-4">
            <Colxx xxs="12">
              <div className="text-center">
                <h6>Add Integration</h6>
                <Separator className="mb-3" />
                <FormGroup className="mb-2 text-left">
                  <Label>Integration Name</Label>
                  <Input
                    type="text"
                    name="Name"
                    onChange={handleChange}
                    placeholder="Integration Name"
                    defaultValue={inputData.Name}
                  />
                </FormGroup>
                <FormGroup className="mb-2 text-left">
                  <Label>Client Id</Label>
                  <Input
                    type="text"
                    name="clientId"
                    onChange={handleClietIdChange}
                    placeholder="Client Id"
                    defaultValue={maskData.clientId}
                  />
                </FormGroup>
                <FormGroup className="mb-2 text-left">
                  <Label>Client Secret</Label>
                  <Input
                    type="text"
                    name="clientSecret"
                    onChange={handleClietSecretChange}
                    placeholder="Client Secret"
                    defaultValue={maskData.clientSecret}
                  />
                </FormGroup>
                {isLoading ? (
                  <div className="text-center">
                    <Spinner color="primary" className="mb-1" />
                  </div>
                ) : (
                  <Fragment>
                    {clientProperties !== undefined &&
                      clientProperties.length > 0 && (
                        <FormGroup className="mb-2 text-left">
                          <Label>Client Url</Label>
                          <Input
                            type="text"
                            name="clientUrl"
                            disabled
                            onChange={handleChange}
                            placeholder="Client Url"
                            defaultValue={inputData.clientUrl}
                          />
                        </FormGroup>
                      )}
                    {clientProperties !== undefined &&
                      clientProperties.length > 0 && (
                        <FormGroup className="mb-2 text-left">
                          <Label>Property Id</Label>
                          <Input
                            type="select"
                            value={inputData?.propertyId}
                            name="propertyId"
                            onChange={(event) => handleChange(event)}
                          >
                            <option value="">Please Select</option>
                            {clientProperties.map((m) => (
                              <option key={m.id} value={m.id}>
                                {m.name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>
                      )}

                    {onlineAgents !== undefined && onlineAgents.length > 0 && (
                      <FormGroup className="mb-2 text-left">
                        <Label>Online Agent</Label>
                        <Input
                          type="select"
                          value={inputData?.onlineAgentId}
                          name="onlineAgentId"
                          onChange={(event) => handleChange(event)}
                        >
                          <option value="">Please Select</option>
                          {onlineAgents.map((m) => (
                            <option key={m.id} value={m.id}>
                              {m.name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>
                    )}
                  </Fragment>
                )}
                <FormGroup>
                  <div className="integration-property">
                    {property.map((p, index) => {
                      return (
                        <CustomInput
                          key={p.id}
                          type="checkbox"
                          id={index}
                          label={p.name}
                          value={p.id}
                          onChange={handleCheckChange}
                          checked={
                            inputData.Properties.includes(p.id) ? true : false
                          }
                        />
                      );
                    })}
                  </div>
                </FormGroup>
                <ButtonGroup className="mb-2" style={{ marginTop: '20px' }}>
                  {id === undefined ? (
                    <Button color="primary" size="xs" onClick={handleSave}>
                      Create New Integration
                    </Button>
                  ) : (
                    <Button color="primary" size="xs" onClick={handleSave}>
                      Update Integration
                    </Button>
                  )}

                  <Button size="xs" color="dark" outline onClick={toggle}>
                    Cancel
                  </Button>
                </ButtonGroup>
              </div>
            </Colxx>
          </Row>
        </ModalBody>
      </Modal>
      <Validation
        open={open}
        messages={msg}
        toggle={() => {
          setOpen(!open);
        }}
      ></Validation>
    </Fragment>
  );
}
